import { render, staticRenderFns } from "./OpenCardsStat.vue?vue&type=template&id=0be93990&"
import script from "./OpenCardsStat.vue?vue&type=script&lang=ts&"
export * from "./OpenCardsStat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports